import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // ← ¡IMPORTANTE!
import App from './app.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
